import { FC, PropsWithChildren } from 'react';

export const AssociatedDealerTitle: FC<PropsWithChildren> = ({ children }) => {
  return <h4 className="cat-u-theme-typography-title m-0">{children}</h4>;
};
